module.exports = __webpack_public_path__ + "static/media/Wire1.6d0d2701.png";